import React, { useEffect, useState } from "react";
import { MainWrapper } from "../component/MainWrapper";
import { Sidebar } from "./Components/Sidebar";
import { AccountSettings } from "./Components/AccountSettings";
import { CompanySettings } from "./Components/CompanySettings";
import { FormattedMessage } from "react-intl";
import CompanyAdditionalInfo from "../CompanyAdditionalInfo";
import { BranchInfoSettings } from "./Components/BranchInfoSettings";
import { Payment } from "./Components/Payment";
import { Balance } from "./Components/Balance";
import { useParams, useSearchParams } from "react-router-dom";
import { History } from "./Components/History";
import { KYCSettings } from "./Components/KYCSettings";
import { CompanySettingData } from "../component/SidebarItems";
import RegionInfoSettings from "../../component/RegionInfoSettings";
export const Settings = () => {
  const [Tab, setTab] = useState("Account Settings");
  const [title, setTitle] = useState(
    <FormattedMessage
      id="RECRUITER.ACCOUNT.SETTINGS.MENU.ACCOUNT.TITLE"
      defaultMessage="Account Settings"
    />,
  );
  const HandleTab = (data) => {
    setTitle(data);
    setTab(data.props.defaultMessage);
  };
  const param = useParams();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const { tab } = param;
    if (tab) {
      setTab(tab);
    }
    if (searchParams.get("tab")) {
      console.log(searchParams.get("tab"));
      let selectedtab = CompanySettingData.find(
        (f) => f.tag && f.tag == searchParams.get("tab"),
      );
      if (selectedtab && Object.keys(selectedtab) && selectedtab.text) {
        HandleTab(selectedtab.text);
      }
    }
  }, [param]);
  return (
    <MainWrapper>
      <div className="py-2 flex space-x-2">
        <Sidebar activeTab={Tab} HandleTabs={HandleTab} />
        <div className="flex-1 bg-white p-10 rounded-lg">
          <h1 className=" text-xl mb-3 pb-3 border-b border-neutral-200">
            {title}
          </h1>
          {Tab === "Account Settings" && <AccountSettings />}
          {Tab === "Company Settings" && <CompanySettings />}
          {/* {Tab === "Additional Info" && (
            <CompanyAdditionalInfo type="setting" />
          )} */}
          {Tab === "Branches" && <BranchInfoSettings />}
          {/* Harendra open next 3 tabs lines */}
          {Tab === "Payment Settings" && <Payment />}
          {/* {Tab === "Account Balance" && <Balance></Balance>} */}
          {/* {Tab === "Transaction History" && <History />} */}
          {/* {Tab === "KYC Settings" && <KYCSettings />} */}
          { Tab === "Regions" && <RegionInfoSettings />}
        </div>
      </div>
    </MainWrapper>
  );
};
